import { AlertColor } from '../../types';
import styles from './styles.module.scss';

type ButtonProps = {
    wrapperClass?: string;
    type?: AlertColor;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    title?: string;
    children: React.ReactNode;
    disabled?: boolean;
};

export const Button = ({ wrapperClass, type, onClick, title, children, disabled }: ButtonProps) => {
    const getColorStyle = () => {
        switch (type) {
            case 'success':
                return styles.success;

            case 'warning':
                return styles.warning;

            case 'error':
                return styles.error;

            case 'default':
                return styles.default;

            default:
                return '';
        }
    };

    return (
        <button
            type='button'
            title={title ?? ''}
            className={`${wrapperClass} ${styles.button} ${getColorStyle()}`}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    );
};
